"use client"

import { useTr } from "../../lib/use-tr"
import { LocaleLink } from "../locale-link"
import { Reveal } from "../reveal"
import { Mail, Sparkles } from "lucide-react"

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion"

import { FAQ_ITEMS, FAQ_T } from "./faq-translations"

export function FAQ() {
  const tr = useTr(FAQ_T)
  return (
    <section
      id="faq"
      aria-labelledby="faq-heading"
      className="scroll-mt-28 py-16 sm:py-20 md:py-24 lg:scroll-mt-40"
    >
      <Reveal className="sm:container">
        <div className="grid gap-12 lg:grid-cols-[5fr_7fr] lg:gap-16">
          <div className="space-y-6 lg:sticky lg:top-32 lg:self-start">
            <div className="bg-card/60 text-muted-foreground inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-xs font-medium backdrop-blur-sm">
              <Sparkles className="text-primary-cta size-3.5" aria-hidden />
              <span>{tr("eyebrow")}</span>
            </div>
            <h2
              id="faq-heading"
              className="font-display leading-display tracking-dense text-3xl font-semibold text-balance sm:text-4xl md:text-5xl"
            >
              {tr("headline")}
            </h2>
            <p className="text-muted-foreground text-md leading-relaxed text-balance sm:text-base">
              {tr("subhead")}
            </p>

            <div className="bg-card ring-border/60 mt-2 flex flex-col gap-4 rounded-2xl border p-6 ring-1 sm:flex-row sm:items-center sm:justify-between">
              <div className="flex items-start gap-3">
                <div className="bg-primary-cta/10 flex size-9 shrink-0 items-center justify-center rounded-lg">
                  <Mail className="text-primary-cta size-4" aria-hidden />
                </div>
                <div className="flex-1 space-y-1">
                  <h3 className="text-base font-semibold tracking-tight">
                    {tr("contact_title")}
                  </h3>
                  <p className="text-muted-foreground text-sm leading-relaxed">
                    {tr("contact_body")}
                  </p>
                </div>
              </div>
              <LocaleLink
                href="/contact"
                className="bg-foreground text-background hover:bg-foreground/90 text-2sm inline-flex h-9 shrink-0 items-center gap-1.5 rounded-lg px-4 font-medium transition-all"
              >
                <Mail className="size-3.5" aria-hidden />
                {tr("contact_cta")}
              </LocaleLink>
            </div>
          </div>

          <div>
            <Accordion type="single" collapsible className="w-full">
              {FAQ_ITEMS.map((item, idx) => (
                <AccordionItem
                  key={item.q}
                  value={item.q}
                  className={
                    idx === 0
                      ? "border-border/70 border-0 border-t border-b last:border-b-0"
                      : "border-border/70 border-0 border-b last:border-b-0"
                  }
                >
                  <AccordionTrigger className="text-foreground text-md py-5 text-left font-medium tracking-tight hover:no-underline [&[data-state=open]>svg]:rotate-180">
                    {tr(item.q)}
                  </AccordionTrigger>
                  <AccordionContent
                    tone="muted"
                    className="pb-5 text-sm leading-relaxed"
                  >
                    {tr(item.a)}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </Reveal>
    </section>
  )
}
